import * as React from "react"
import { Box, Flex, FlexList, Space, Text } from "./ui"
import ListNumber from "./list-numbers"
import { numberedListIconDiv, numberedListText } from "./numbered-list.css"

function ListItem(props) {
  return (
    <Flex
      variant={props.isVertical && "responsive"}
      flexDirection={props.isVertical ? "" : "columnStartEvenSize"}
    >
      <Flex
        variant={!props.isVertical && "numberedListIconHorizontal"}
        className={numberedListIconDiv}
      >
        <Box width={"fit-content"}>
          <ListNumber
            number={props.number}
            width={props.isVertical ? "40" : "65"}
            height={props.isVertical ? "40" : "65"}
          />
        </Box>
      </Flex>
      <Space size={3} />
      <Text center={props.isVertical ? false : true}>
        <div
          className={numberedListText}
          dangerouslySetInnerHTML={{
            __html: props.body,
          }}
        />
      </Text>
    </Flex>
  )
}

export default function NumberedList(props) {
  return (
    <FlexList
      responsive={!props.isVertical && true}
      variant={props.isVertical ? "columnStart" : "flexStart"}
    >
      {props.content.map((listItem, index) => (
        <ListItem
          key={listItem.id}
          number={index + 1}
          isVertical={props.isVertical}
          {...listItem}
        />
      ))}
    </FlexList>
  )
}
